import { render, staticRenderFns } from "./SectionTimeAnswer.vue?vue&type=template&id=2d4e4ab6&scoped=true&"
import script from "./SectionTimeAnswer.vue?vue&type=script&lang=js&"
export * from "./SectionTimeAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SectionTimeAnswer.vue?vue&type=style&index=0&id=2d4e4ab6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e4ab6",
  null
  
)

export default component.exports